module.exports = __webpack_public_path__ + "static/media/Rapport3.d4628fd3.png";